.container {
  border: 1px solid;
  border-radius: var(--dds-border-radius-surface);

  @media (prefers-reduced-motion: no-preference) {
    transition:
      box-shadow var(--dds-motion-micro-state),
      border-color var(--dds-motion-micro-state),
      var(--dds-focus-transition);
  }
}

.container--filled {
  background-color: var(--dds-color-brand-primary-subtle);
  border-color: var(--dds-color-brand-primary-subtle);
  color: var(--dds-color-text-on-primary-subtle);
}

.container--border {
  background-color: var(--dds-color-surface-default);
  border-color: var(--dds-color-border-subtle);
}

.container--navigation:hover,
.container--selection-control:has(
    input:enabled:not([aria-readonly='true'])
  ):hover {
  border-color: var(--dds-color-border-action-hover);
  box-shadow: inset 0 0 0 1px var(--dds-color-border-action-hover);
}

.container--selection-control {
  padding: var(--dds-selection-control-card-padding);
  display: block;
  width: 100%;
  height: 100%;

  & > span {
    left: var(--dds-selection-control-card-control-left);
    top: var(--dds-selection-control-card-control-top);
  }

  input:disabled,
  input[aria-readonly='true'] {
    & ~ span {
      background-color: var(--dds-color-surface-field-disabled);
    }
  }

  &:has(input:checked) {
    border-color: var(--dds-color-surface-action-selected);
    box-shadow: inset 0 0 0 1px var(--dds-color-surface-action-selected);
    background-color: var(--dds-color-surface-selected-default);
  }

  &:has(input[aria-invalid]) {
    border-color: var(--dds-color-border-danger);
    box-shadow: inset 0 0 0 1px var(--dds-color-border-danger);
  }

  &:has(input:disabled) {
    color: var(--dds-color-text-subtle);
  }
  &:has(input:disabled),
  &:has(input[aria-readonly='true']) {
    box-shadow: none;
    background-color: var(--dds-color-surface-selected-default);
    background-color: var(--dds-color-surface-field-disabled);
    border-color: var(--dds-color-surface-field-disabled);
  }
}

.container--navigation {
  text-decoration: none;
  display: block;
}

.container--expandable {
  width: 100%;
  box-sizing: border-box;
  & + .container--expandable {
    border-top: none;
  }
}
